/**
 * Formats bytes into a human-readable string (KB, MB, GB, etc.).
 * Uses base 1024 (KiB, MiB, GiB).
 *
 * @param {number} bytes The number of bytes.
 * @param {number} [decimals=2] The number of decimal places to display.
 * @returns {string} The formatted string.
 */
export function formatBytes(bytes, decimals = 2) {
    // Handle edge case of 0 bytes or invalid input
    if (bytes === 0 || !+bytes) return '0 Bytes';
  
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  
    // Determine the magnitude (Bytes=0, KB=1, MB=2, etc.)
    const i = Math.floor(Math.log(bytes) / Math.log(k));
  
    // Handle potential floating point inaccuracies or extremely large numbers
    const unitIndex = Math.min(i, sizes.length - 1);
  
    // Calculate the value in the chosen unit and format it
    const sizeInUnit = parseFloat((bytes / Math.pow(k, unitIndex)).toFixed(dm));
  
    return `${sizeInUnit} ${sizes[unitIndex]}`;
  }
  
  /* Example Usage:
     formatBytes(0);           // -> "0 Bytes"
     formatBytes(500);          // -> "500.00 Bytes" (adjust decimals if needed)
     formatBytes(1024);         // -> "1.00 KB"
     formatBytes(2097152);    // -> "2.00 MB"
     formatBytes(1073741824); // -> "1.00 GB"
     formatBytes(1500000000); // -> "1.40 GB"
  */